import { useEffect, useState } from 'react';
import useAxios from '../axios/useAxios';
import SuccessAnimation from '../components/successAnimation';

import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { resetCartNavigation } from '../utils/cartItem.js';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { useUserLoginStatus } from '../utils/hooks';
import { notifyError } from '../utils/Notify';
import { usePerformanceContext } from '../context/PerformanceContext.jsx';

const ReceiptScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosInstance = useAxios();

  const { markComplete } = usePerformanceContext();
  const { orderId } = useParams();
  const [cartItems, setCartItems] = useState(null);
  const { trackPageViewReceipt, trackFunnelCompleted } = useFunnelTracking();
  const isLoggedIn = useUserLoginStatus();
  
  useEffect(() => {
    trackPageViewReceipt({});
    trackFunnelCompleted({
      transaction_id: cartItems?._id,
      order_value: cartItems?.promoPrice || cartItems?.itemsPrice || 0,
      items_purchased: cartItems?.orderItems?.length || 0,
      payment_method: cartItems?.paymentMethod,
      user_loggedIn: isLoggedIn,
    });
  }, [trackPageViewReceipt, cartItems?._id]);


  useEffect(() => {

    const isPageFullyLoaded = cartItems && markComplete && orderId && axiosInstance;  
    if (isPageFullyLoaded) {
      markComplete();
    }
  }, [cartItems, orderId, axiosInstance, markComplete]);

  const earnPoints = () => {
    if (!cartItems) return 0;

    const orderItems = cartItems?.orderItems ?? [];

    return orderItems.reduce((total, { fidelity = 0, Qty = 0 }) => {
      return total + fidelity * Qty;
    }, 0);
  };

  useEffect(() => {
    resetCartNavigation(dispatch);
  }, [dispatch]);

  useEffect(() => {
    const retrieveOrderById = async (orderId) => {
      if (!orderId) {
        navigate('/');
      }

      try {
        const currentOrder = await axiosInstance.get(`/orders/${orderId}`);
        if (!currentOrder
          || currentOrder.data?.message === 'Order not found'
          || currentOrder.data?.message === 'Server Error') {
          notifyError('Reçu', "Le reçu n'a pas été trouvé", () => navigate('/'), 3500);
        }
        else setCartItems(currentOrder.data);
      } catch (error) {
        console.error('checkIfOrderhasBeenAlreadyPaid error', error);
        navigate('/');
      }
    };

    retrieveOrderById(orderId);
  }, [orderId, axiosInstance]);

  if (!cartItems) return null;

  return (
    <SuccessAnimation cartItems={cartItems} earnPoints={earnPoints()} />
  );
};
export default ReceiptScreen;
